import React, { useMemo } from 'react'
import PropTypes from 'helpers/proptypes'
import { Label, Popup } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { konstants } from '@vizeat/helpers'
import { isBoolean, isEmpty, isString } from 'lodash'

function usePaymentPreferences(user) {
  const { t } = useTranslation()

  const isMissingStripeRequirements = useMemo(
    () =>
      user.get('tags').some((tag) => {
        const tagTitle = isString(tag) ? tag : tag.get('title')
        return [konstants.TAGS.STRIPE_PAYOUTS_DISABLED, konstants.TAGS.STRIPE_CHARGES_DISABLED].includes(tagTitle)
      }),
    [user],
  )

  const isMissingBankAccountInCurrentCurrency = !user.get('has_bank_account_in_current_currency')
  const arePaymentPreferencesSet = !isMissingStripeRequirements && !isMissingBankAccountInCurrentCurrency
  const labelMessage = arePaymentPreferencesSet ? t('Labels::set') : t('Labels::not set')
  const popupBaseMessage = t('Labels::Payment preferences {{labelMessage}}', { labelMessage })

  const popupMessage = useMemo(() => {
    if (arePaymentPreferencesSet) return labelMessage

    let unsetPaymentReason

    switch (true) {
      case isMissingStripeRequirements:
        unsetPaymentReason = t('PaymentPreferencesLabel::missing Stripe requirements')
        break
      case isMissingBankAccountInCurrentCurrency:
        unsetPaymentReason = t("PaymentPreferencesLabel::missing bank account in host's currency")
        break
      default:
        unsetPaymentReason = undefined
    }

    return unsetPaymentReason ? [popupBaseMessage, `(${unsetPaymentReason})`].join(' ') : popupBaseMessage
  }, [
    arePaymentPreferencesSet,
    isMissingBankAccountInCurrentCurrency,
    isMissingStripeRequirements,
    labelMessage,
    popupBaseMessage,
    t,
  ])

  return {
    arePaymentPreferencesSet,
    labelMessage: labelMessage.toUpperCase(),
    popupMessage,
  }
}
export function PaymentPreferencesLabel({ user }) {
  const { arePaymentPreferencesSet, labelMessage, popupMessage } = usePaymentPreferences(user)

  if ((isBoolean(user.isHost) === 'boolean' && !user.isHost) || (!isEmpty(user.type) && user.type !== 'host'))
    return null

  return (
    <Popup
      content={popupMessage}
      inverted
      trigger={
        <div>
          <Label style={{ cursor: 'pointer' }} color={arePaymentPreferencesSet ? 'green' : 'red'} horizontal>
            {' '}
            {labelMessage}
          </Label>
        </div>
      }
    />
  )
}

PaymentPreferencesLabel.propTypes = {
  user: PropTypes.immutable.record.isRequired,
}
